
import React, { Component } from 'react';

class Error extends Component {
    
    render() {
        return (  
            <div id="detailBody" className="Site-content" >
                    <div className="loader"></div> 
                    <div hidden={true} id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <div id="Body" className="body-container container-fluid">
                                <div className="content-option">
                                    {((this.props.StatusCode===500)
                                    ?
                                    (
                                        <div className="alert alert-danger" role="alert">
                                            <strong>¡Error!</strong> {this.props.StatusMessage}
                                        </div>
                                    )
                                    :
                                    (
                                        <div className="alert alert-warning" role="alert">
                                            <strong>¡Alerta!</strong> {this.props.StatusMessage}
                                        </div>   
                                    )
                                    )}
                            </div>
                        </div>    
                    </div>
                </div>
            </div>  
        );
    }
}



export default Error;